import { useContext } from 'react'

import Context from './Context'

const usePanel = () => {
  return useContext(Context)
}

export default usePanel
